module.exports = __webpack_public_path__ + "img/goods1_6.f4149075.jpg";